import {useApp} from "../app.context";
import {useIntegrator} from "../integrator.context";

interface ImagePackElementProps {
    id: string;
    size?: number;
    background?: string;
    // Optional level to render from the pack. When set, the element looks up
    // imagePacks[id][level][0] (with clamping) instead of using the raw
    // id-keyed image. Buildings pass `startLevel` so the card icon matches
    // what the runtime displays at placement — and what the editor's pack
    // popup labels "Level <startLevel>" (since the pack popup hides pack[0]
    // for buildings). For units / tiles / resources, omit this prop; the
    // default id-keyed lookup is what their callers want.
    level?: number;
}

function ImagePackElement(props: ImagePackElementProps) {
    const {setImagePackId, getImageUrl} = useApp();
    const {state} = useIntegrator();

    let imageKey = props.id;
    if (props.level !== undefined) {
        const pack = state.imagePacks?.[props.id];
        if (pack && pack.length > 0) {
            const clamped = Math.max(0, Math.min(pack.length - 1, props.level));
            const variations = pack[clamped];
            if (variations && variations.length > 0) imageKey = variations[0];
        }
    }

    return (
        <div onClick={(e) => {
            // Don't let the click bubble to a surrounding label / drag wrapper
            // (e.g. EntityDragLabel) — the image-pack picker is the intended
            // affordance for clicks on the image, not the entity's description
            // popup or anything else higher up.
            e.stopPropagation();
            setImagePackId(props.id);
        }} style={{
            position: 'relative',
            borderRadius: 5,
            width: props.size ?? 50,
            height: props.size ?? 50,
            backgroundColor: props.background ?? 'black',
            border: 'solid 1px #515151',
            boxShadow: '3px 3px #6c6c6c4d, 6px 6px #6c6c6c33'
        }}
        >
            <img alt={props.id} style={{
                borderRadius: 5,
                width: '100%',
                height: '100%'
            }}
                 src={getImageUrl(imageKey)}
            />
        </div>
    )
}

export default ImagePackElement;